import { Injectable } from '@angular/core';
import { ApiService } from '../..';
import { UserService } from '../../common/user.service';

@Injectable()
export class CanhBaoMatDienService {

  constructor(private api: ApiService, private user: UserService) { }
  layDanhSachCanhBao(tungay, denngay, danhmucid, macanhbao, sotrang, sodong) {
    let curUs = this.user.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CANHBAO_MATDIEN"}',
      "para": '{"V_TUNGAY":"' + tungay + '","V_DENNGAY":"' + denngay + '","v_DANHMUCID":"' + danhmucid + '","v_MACANHBAO":"' + macanhbao + '","v_SOTRANG":"' + sotrang + '","v_SODONG":"' + sodong + '","v_MATAIKHOAN":"' + curUs.mataikhoan + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  layDanhSachCanhBaoNhietDo_CamBien(tungay, denngay, danhmucid, sotrang, sodong) {
    //let curUs = this.user.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_GIAMSATCAMBIEN.P_LAYDS_CANHBAO_NHIET_CAMBIEN"}',
      "para": '{"V_TUNGAY":"' + tungay + '","V_DENNGAY":"' + denngay + '","v_DANHMUCID":"' + danhmucid +  '","v_SOTRANG":"' + sotrang + '","v_SODONG":"' + sodong   + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  layds_CanhBaoNhietDo_chenhlech_30(tungay, denngay, danhmucid, sotrang, sodong) {
    //let curUs = this.user.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_GIAMSATCAMBIEN.P_LAYDS_CANHBAO_CHENHLECH_30"}',
      "para": '{"V_TUNGAY":"' + tungay + '","V_DENNGAY":"' + denngay + '","v_DANHMUCID":"' + danhmucid +  '","v_SOTRANG":"' + sotrang + '","v_SODONG":"' + sodong   + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }



  exportExcelChiSoBatThuong(tungay, denngay, danhmucid,tendonvi, tenchucnang, noidungbaocao) {
    let cols =
      [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "imei", "label": "Mã điểm đo", "horizontalalignment": "left" },      
        { "name": "thoigianbatthuong", "label": "Thời điểm bất thường", "horizontalalignment": "center" },
        { "name": "pgiaotong", "label": "Chỉ số bất thường", "horizontalalignment": "right" },
        { "name": "thoigianbantin", "label": "Thời điểm trước bắt thường", "horizontalalignment": "left" },
        { "name": "cstruoc", "label": "Chỉ số trước bất thường", "horizontalalignment": "right" },
      ]
    let curUs = this.user.getCurrentUser();
    let para: any = JSON.stringify({
      V_TUNGAY: tungay,
      V_DENNGAY: denngay,
      v_DANHMUCID: danhmucid,
      v_sotrang: 0,
      v_sodong: 1000000,
      v_mataikhoan: curUs.mataikhoan,
    });
    let config = JSON.stringify({ namesql: "PKG_CANHBAO.P_LAYDS_CHISO_BATTHUONG" });

    let strDate = "Từ ngày " + tungay + " đến ngày " + denngay;

    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi,
      header: strDate,
      filename: "",
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, fileName);

  }
  layDanhSachChiSoBatThuong(tungay, denngay, danhmucid, sotrang, sodong) {
    let curUs = this.user.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CHISO_BATTHUONG"}',
      "para": '{"V_TUNGAY":"' + tungay + '","V_DENNGAY":"' + denngay + '","v_DANHMUCID":"' + danhmucid + '","v_SOTRANG":"' + sotrang + '","v_SODONG":"' + sodong + '","v_MATAIKHOAN":"' + curUs.mataikhoan + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  exportExcel(tungay, denngay, danhmucid, macanhbao, tendonvi, tenchucnang, noidungbaocao) {
    let cols =
      [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "meterid", "label": "Meterid", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "noidungcanhbao", "label": "Nội dung cảnh báo", "horizontalalignment": "left" },
        { "name": "tgcanhbao", "label": "Thời điểm mất điện", "horizontalalignment": "center" },
        { "name": "tghetcanhbao", "label": "Thời điểm có điện", "horizontalalignment": "center" },
        { "name": "thoigianmatdientext", "label": "Tổng thời gian mất điện", "horizontalalignment": "left" },
        { "name": "khacphuctext", "label": "Trạng thái khắc phục", "horizontalalignment": "left" },
      ]
    let curUs = this.user.getCurrentUser();
    let para: any = JSON.stringify({
      V_TUNGAY: tungay,
      V_DENNGAY: denngay,
      v_DANHMUCID: danhmucid,
      v_MACANHBAO: macanhbao,
      v_sotrang: 0,
      v_sodong: 1000000,
      v_mataikhoan: curUs.mataikhoan,
    });
    let config = JSON.stringify({ namesql: "PKG_CANHBAO.P_LAYDS_CANHBAO_MATDIEN" });

    let strDate = "Từ ngày " + tungay + " đến ngày " + denngay;

    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi,
      header: strDate,
      filename: "",
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, fileName);

  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/canh-bao/canh-bao-mat-dien/canhbaomatdien.service.ts